import { createDefaultRow, createDefaultRows, createHeaderRow } from 'helpers/businessTool';

// ---- ROWS ----
export const personnelExpensesRows = [
  'Production employees (fixed expenses)',
  'Production employees (variable expenses)',
  'Administrative staff',
  'Marketing and sales personnel',
  'R&D staff',
];

// ---- COLUMNS ----
export const personnelExpensesColumns = [
  'Number of Employees',
  'Average monthly salary',
  'Total monthly payroll expenses',
  'Annual expense growth rate, %',
];

export const ROWS_LENGTH = personnelExpensesRows.length;
export const COLUMNS_LENGTH = personnelExpensesColumns.length;

export const PERSONNEL_EXPENSES_FORM_NAMES = {
  PERSONNEL_EXPENSES_VARIANTS: 'personnelExpensesVariants',
  PERSONNEL_EXPENSES_HEADER: 'personnelExpensesHeader',
  PERSONNEL_EXPENSES_TABLE: 'personnelExpensesTable',
  PERSONNEL_EXPENSES_TOTAL: 'total',
} as const;

const defaultPersonnelExpensesRows = createDefaultRows(COLUMNS_LENGTH, ROWS_LENGTH);
const emptyPersonnelExpensesRow = createDefaultRow(COLUMNS_LENGTH);
const headerPersonnelExpensesRow = createHeaderRow(personnelExpensesColumns);

export const personnelExpensesColumnsNames = Object.keys(emptyPersonnelExpensesRow);

// ---- COMMON ----

type IRow = Record<string, string | number | undefined>;
export interface IPersonnelExpensesFormValuesType {
  [PERSONNEL_EXPENSES_FORM_NAMES.PERSONNEL_EXPENSES_VARIANTS]: string[];
  [PERSONNEL_EXPENSES_FORM_NAMES.PERSONNEL_EXPENSES_HEADER]?: IRow;
  [PERSONNEL_EXPENSES_FORM_NAMES.PERSONNEL_EXPENSES_TABLE]: IRow[];
  [PERSONNEL_EXPENSES_FORM_NAMES.PERSONNEL_EXPENSES_TOTAL]: IRow;
}

export const personnelExpensesInitialValues = {
  [PERSONNEL_EXPENSES_FORM_NAMES.PERSONNEL_EXPENSES_VARIANTS]: personnelExpensesRows,
  [PERSONNEL_EXPENSES_FORM_NAMES.PERSONNEL_EXPENSES_HEADER]: headerPersonnelExpensesRow,
  [PERSONNEL_EXPENSES_FORM_NAMES.PERSONNEL_EXPENSES_TABLE]: defaultPersonnelExpensesRows,
  [PERSONNEL_EXPENSES_FORM_NAMES.PERSONNEL_EXPENSES_TOTAL]: emptyPersonnelExpensesRow,
};
